import {Component, Input, ViewEncapsulation} from '@angular/core';
import {SvgIconUtils} from '../../svg-icon/svg-icon-utils';

@Component({
  selector: 'ld-input-password-policy-message',
  templateUrl: 'input-password-policy-message.component.html',
  styleUrls: [ './input-password-policy-message.style.scss' ],
  encapsulation: ViewEncapsulation.None
})
export class InputPasswordPolicyMessageComponent {

  public checkMarkIconPath = SvgIconUtils.checkMarkPath;

  @Input() hasError: boolean;

  constructor() { }


}
